import { TiledResource } from '@excaliburjs/plugin-tiled';
import { DefaultLoader, ImageSource, Sound } from 'excalibur';

export const Resources = {
  background: new ImageSource('./background-assets/background.png'),
  Santa: new ImageSource('./images/santa.png'),
  Elf: new ImageSource('./images/elf.png'),

  Level1: new TiledResource('./levels/level1.tmx'),
  //  need to be later version in Tiled (open, save, shoudl be enough)
  // Level2: new TiledResource('./levels/level2.tmx'),
  // Level3: new TiledResource('./levels/level3.tmx'),
  // Level4: new TiledResource('./levels/level4.tmx'),
  // Level5: new TiledResource('./levels/level5.tmx'),

  ball: new ImageSource('./tileset-assets/ball.png'),
  bear: new ImageSource('./tileset-assets/bear.png'),
  candyCane: new ImageSource('./tileset-assets/candy-cane.png'),
  fgTiles: new ImageSource('./tileset-assets/fg-tiles.png'),
  frame: new ImageSource('./tileset-assets/frame.png'),
  gift: new ImageSource('./tileset-assets/gift.png'),
  workshop: new ImageSource('./tileset-assets/room-bg.png'),
  snowFlake1: new ImageSource('./tileset-assets/snow-flake-1.png'),
  snowFlake2: new ImageSource('./tileset-assets/snow-flake-2.png'),
  snowFlake3: new ImageSource('./tileset-assets/snow-flake-3.png'),
  star: new ImageSource('./tileset-assets/star.png'),
  wall: new ImageSource('./tileset-assets/wall.png'),

  Beep: new Sound('./sfx/beep.mp3'),
  Jump: new Sound('./sfx/jump.mp3'),
  Dreams: new Sound('./sfx/dreams.mp3'),
  Strike: new Sound('./sfx/strike.mp3'),
} as const;

export const loader = new DefaultLoader();
// export const loader = new Loader();
for (const res of Object.values(Resources)) {
  loader.addResource(res);
}
